<template>
    <div class='role-permission pt-12 pb-12'
        :style="{ justifyContent: justifyContent }">
        <template v-if="isCanGoInBackstage">
            <p class="title">进入零售后台</p>
            <div class="fx" style="flex-wrap: wrap">
                <span v-for="item in backstagePermissions"
                    class="sub-title"
                    :key="item">{{ permissionMap[item] }}</span>
            </div>
        </template>
        <template v-if="isCanGoInCashier">
            <p class="title">进入收银台</p>
            <div class="fx" style="flex-wrap: wrap">
                <span v-for="item in cashierPermissions"
                    class="sub-title"
                    :key="item">{{ permissionMap[item] }}</span>
            </div>
        </template>
        <template v-if="isCanGoAppRole">
            <p class="title">进入零售通app</p>
            <div class="fx" style="flex-wrap: wrap">
                <span v-for="item in appRolePermissions"
                    class="sub-title"
                    :key="item">{{ permissionMap[item] }}</span>
            </div>
        </template>
        <template v-if="!isCanGoInBackstage && !isCanGoInCashier && !isCanGoAppRole">
            <p class="title">暂无角色权限</p>
        </template>
    </div>
</template>

<script lang='ts'>
import { createComponent, ref } from '@vue/composition-api'
import permissionMap from '@/config/permisstion_map'

// 0   # 超管权限
// 1   # 进入零售后台权限
// 2   # 进入收银台
// 3   # 店铺数据权限
// 4   # 会员管理权限
// 5   # 店铺设置权限
// 6   # 添加员工权限
// 7   # 删除员工权限
// 8   # 编辑/配置角色
// 9   # 订单退款权限
// 10  # 添加/删除商品权限
// 11  # 上架或下架商品权限
// 12  # 收银员改价
// 13  # 收银员订单减免
// 14  # 收银台退款
// 15  # 收银台折扣
// 16  # 收银台抹零
// 17: # 进入App权限
// 18: # 店铺数据
// 19: # 会员管理
// 20: # 店铺设置
// 21: # 添加员工
// 22: # 删除员工
// 23: # 编辑/配置角色
// 24: # 订单退款
// 25: # 添加/删除商品
// 26: # 商品上/下架
// 28  # 删除手工会员
// 29  # 查看收银数据

export default createComponent({
    props: {
        permissionList: {
            type: Array,
            default: () => []
        },
        justifyContent: {
            type: String,
            default: 'center'
        }
    },

    computed: {
        permissionMap() {
            return permissionMap
        },
        permissionMapLen() {
            return Object.keys(permissionMap).length
        },
        // 是否能进后台
        isCanGoInBackstage() {
            return (this.permissionList as number[]).includes(1)
        },
        // 是否能进收银台
        isCanGoInCashier() {
            return (this.permissionList as number[]).includes(2)
        },
        // 是否能进入app
        isCanGoAppRole() {
            return (this.permissionList as number[]).includes(17)
        },
        // 后台相关权限 3~11
        backstagePermissions() {
            return (this.permissionList as number[]).filter(num => (num > 2 && num < 12))
        },
        // 收银台相关权限 13~16
        cashierPermissions() {
            return (this.permissionList as number[]).filter(num => ((num > 11 && num < 17) || num === 29))
        },
        // app相关权限 18-28
        appRolePermissions() {
             return (this.permissionList as number[]).filter(num => ((num > 17 && num < 27 && num !== 19 && num !== 20) || num === 28))
        }
    }
})
</script>

<style lang="scss" scoped>
.mt-4 {
    line-height: 1;
}

.role-permission {
    display: flex;
    justify-content: center;
    flex-direction: column;
    min-height: 88px;
}

.title {
    line-height: 20px;
    font-size: 14px;
    color: #333;

    &:not(:nth-child(1)) {
        margin-top: 8px;
    }
}

.sub-title {
    flex: none;
    line-height: 16px;
    margin-top: 4px;
    font-size: 12px;
    color: #666;

    &:not(:last-child) {
        margin-right: 9px;
    }
}
</style>
